import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DistancePipe } from './distance/distance';
import { OrderByPipe } from './order-by/order-by';
import { TruncatePipe } from './truncate/truncate';
import { DurationPipe } from './duration/duration';
import { JoinPipe } from './join/join';
import { GenericTransformPipe } from './generic/generic';
import { SplitByPipe } from './split-by/split-by';
import { LanguagePipe } from './language/language';

@NgModule({
    declarations: [DistancePipe, OrderByPipe, TruncatePipe, DurationPipe, JoinPipe, GenericTransformPipe, SplitByPipe, LanguagePipe],
    imports: [CommonModule],
    exports: [DistancePipe, OrderByPipe, TruncatePipe, DurationPipe, JoinPipe, GenericTransformPipe, SplitByPipe, LanguagePipe]
})
export class MotePipesModule { }
